import "whatwg-fetch";
const env = process.env;

const switchFacility = payload => {
  return fetch(
    `${env.VUE_APP_trimaster}/api/v1/users/switchFacility?access_token=${payload.apitoken}&env=${env.VUE_APP_env}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    }
  );
};

export default {
  switchFacility
};
